import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
// import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
// import Form from 'react-bootstrap/Form';
// import { FormControl } from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { clearMessage } from '../../redux/message_block/Message';
import EventBus from '../../common/EventBus';
import { logout } from '../../redux/account_block/accountActions';
import image from '../home_block/favyt/Favyt_Logo.png';
import './NavBar.css';

function NavBar() {
  const [activeNavItem, setActiveNavItem] = useState(null);
  const { isLoggedIn, user: currentUser } = useSelector((state) => state.Account);
  const handleNavItemClick = (itemName) => {
    setActiveNavItem(itemName);
  };

  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (['/login', '/register'].includes(location.pathname)) {
      dispatch(clearMessage()); // clear message when changing location
    }
  }, [dispatch, location]);

  const logOut = useCallback(() => {
    dispatch(logout());
  }, [dispatch]);

  useEffect(() => {
    EventBus.on('logout', () => {
      logOut();
    });

    return () => {
      EventBus.remove('logout');
    };
  }, [logOut]);

  function handleUserName() {
    const { email } = currentUser.meta;
    return email.substring(0, email.indexOf('@'));
  }

  return (
    <Navbar expand="lg" className="bg-primary">
      <Container fluid>
        <Navbar.Brand href="/" className="me-3 text-white">
          <img
            className="d-inline-block align-top"
            width="50"
            height="30"
            src={image}
            alt="Favyt Technology"
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav className="me-auto" navbarScroll>
            {isLoggedIn && (
              <>
                {/* <Nav.Link
                  as={Link}
                  to="/home"
                  className={`nav-link ${activeNavItem === 'Home' ? 'active' : ''}`}
                  onClick={() => handleNavItemClick('Home')}
                >
                  Home
                </Nav.Link> */}
                <Nav.Link
                  as={Link}
                  to="/dashboard"
                  className={`nav-link ${activeNavItem === 'Dashboard' ? 'active' : ''}`}
                  onClick={() => handleNavItemClick('Dashboard')}
                >
                  Dashboard
                </Nav.Link>
              </>
            )}
            <Nav.Link
              as={Link}
              to="/aboutus"
              className={`nav-link ${activeNavItem === 'AboutUs' ? 'active' : ''}`}
              onClick={() => handleNavItemClick('AboutUs')}
            >
              About Us
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/contactus"
              className={`nav-link ${activeNavItem === 'ContactUs' ? 'active' : ''}`}
              onClick={() => handleNavItemClick('ContactUs')}
            >
              Contact Us
            </Nav.Link>
          </Nav>
          {/* <Form className="d-flex mx-auto">
            <div className="search-container">
              <div className="search-icon">
                <i className="icon-search" />
              </div>
              <FormControl
                type="search"
                placeholder="Search for a company"
                aria-label="Search"
                className="search-input"
              />
            </div>
            <Button variant="primary">Search</Button>
          </Form> */}
          <Nav className="ms-auto" navbarScroll>
            {isLoggedIn ? (
              <>
                <NavDropdown title={handleUserName()} id="navbarScrollingDropdown" className="nav-link">
                  <NavDropdown.Item as={Link} to="/profile">
                    <i className="icon-settings" />
                    Profile
                  </NavDropdown.Item>
                  <NavDropdown.Item href="#alert">
                    <i className="icon-bell" />
                    Alert
                  </NavDropdown.Item>
                  <NavDropdown.Item href="#notebook">
                    <i className="icon-book-open" />
                    Notebook
                  </NavDropdown.Item>
                  <NavDropdown.Item href="#upgrade">
                    <i className="icon-crown" />
                    Upgrade
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item href="/" onClick={logOut}>
                    <i className="icon-off" />
                    Logout
                  </NavDropdown.Item>
                </NavDropdown>
              </>
            ) : (
              <>
                <Nav.Link as={Link} to="/login" className={`nav-link ${activeNavItem === 'Login' ? 'active' : ''}`}>
                  Login
                </Nav.Link>
                <Nav.Link as={Link} to="/signup" className={`nav-link ${activeNavItem === 'Signup' ? 'active' : ''}`}>
                  Signup
                </Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
